if (!customElements.get('odd-quantity-offers')) {
  customElements.define('odd-quantity-offers', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-odd-quantity]');
        if (!button) return;
        const form = document.getElementById(this.dataset.formId);
        const submit = form?.querySelector('[type="submit"][name="add"], .product-form__submit');
        const quantity = form?.querySelector('[name="quantity"]');
        const error = this.querySelector('.odd-offer-error');
        if (!form || !quantity || !submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true') {
          error.hidden = false;
          return;
        }
        error.hidden = true;
        quantity.value = button.dataset.oddQuantity;
        quantity.dispatchEvent(new Event('input', { bubbles: true }));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
        submit.click();
      });
    }
  });
}
